import { useState, useEffect } from "react";
import styles from "./EventCard.module.scss";
import { useTranslation } from "react-i18next";
import OptionsGroup from "./OptionsGroup";
import _ from "lodash";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const EventCard = (props) => {
  const { t } = useTranslation();
  const { data, error, setValue, trigger, setPrice } = props;
  const { name, poster } = data || {};
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [optionsList, setOptionsList] = useState([]);
  const [dirty, setDirty] = useState(false);

  // Add unique Id to every options and put it into a optionList
  const initsku = () => {
    return data.sku.map((groupData) => {
      const _options = groupData.options.map((option) => {
        option.id = _.uniqueId("opt_");
        setOptionsList((prev) => {
          const _prev = [...prev];
          _prev.push(option);
          return _prev;
        });
        return option;
      });
      groupData.options = _options;
      return groupData;
    });
  };
  const [sku, setSku] = useState(initsku);

  const optionsGroupProps = {
    optionProps: {
      setDirty,
      setValue,
      selectedOption,
      setSelectedOption,
      setPrice,
    },
  };

  useEffect(() => {
    if (dirty) trigger("option");
  }, [dirty, trigger, selectedOption]);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <div className="image-div">
          <img src={poster} alt="event-detail-poster" />
        </div>
        <div className="options-div">
          <h1>{name}</h1>

          <div className="input-div full-width">
            <TextField
              sx={{ width: "100%" }}
              label={t("Phone No.")}
              variant="standard"
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
              }}
              error={!!error}
              helperText={error ? error.message : null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
